<template>
	<div id="footer-block" style="">
		<div class="center center-padding" style="">

			<div id="footer" class="center" style="padding-top:30px;max-width:1200px;">

				<div class="flexcenter" style="padding:20px;justify-content: start;">

					<WebContent name="START_FOOTER" :header="true" :footer="true" />
				</div>


				<div id="footerList" style="">

					<div style="" class="box">

						<div class="flexcenter header">
							<Circle fileName="w3_phone_white" color="" hover="" style="margin-right:5px;" @click="this.callBoove()" />
							<h3>Kontakta oss</h3>
						</div>

						<WebContent name="START_FOOTER_TELEPHONE" :footer="true" :spinner="false" />

						<div class="flexcenter" style="justify-content: start;gap:10px;margin-top:20px; ">
							<a href="http://www.instagram.com/boove.se" target="_blank"> <img src="@/assets/w3_instagram_white.png"
									style="height:40px;width:40px;" title="Följ oss på instagram" /></a>
							<a href="https://www.facebook.com/BoOve/" target="_blank">
								<img src="@/assets/w3_facebook_white.png" style="height:40px;width:40px;"
									title="Följ oss på facebook" /></a>
						</div>



					</div>
					<div style="" class="box">
						<div class="flexcenter header">
							<Circle fileName="w3_delivery_white" color="" hover="" style="margin-right:5px;" cursor="default" />
							<h3> Address</h3>
						</div>
						<WebContent name="START_FOOTER_ADDRESS" :footer="true" :spinner="false" />
					</div>

					<div style="" class="box">
						<div class="flexcenter header">
							<Circle fileName="w3_location_white" color="" hover="" style="margin-right:5px;" cursor="default" />
							<h3>Våra återförsäljare</h3>
						</div>

						<WebContent name="START_FOOTER_RESELLER" :footer="true" :spinner="false" />


						<div class="flexcenter link" style="justify-content:end;margin-top:20px;"
							@click="this.$router.push({ name: 'Reseller' })">
							<b>Visa våra återförsäljare</b>
							<Icon fileName="w3_chevron_right_white" style="width:8px;height:12px;margin-left:5px;" />
						</div>




					</div>

					<div style="" class="box">
						<div class="flexcenter header">
							<Circle fileName="w3_outlet_white" color="" hover="" style="margin-right:5px;" cursor="default" />
							<h3>Priser och returer</h3>
						</div>



						<WebContent name="START_FOOTER_PRICE_INFO" :footer="true" :spinner="false" />

					</div>



				</div>
			</div>

		</div>
		<div style="text-align: center;margin-top:150px;margin-bottom:150px;">

			<img src="@/assets/logo_white.png" style="max-width:600px;width:80%;margin-top:100px;" />
		</div>
		<div style="text-align:center;margin-top:80px;font-weight: bold;padding-bottom:100px;color:grey;">
			&copy; {{ this.currentYear }} BOOVE.SE <br />
			<b class="font-smaller" style="color:grey;">
				<Build />
			</b>
		</div>
	</div>

</template>

<script>

//import { PRODUCT_STORE_ACTION } from "../store/product-store";
//import EventList from './components/event-log/EventList.vue';

import { webContentMixin } from "@/mixins/webContentMixin.js";
import WebContent from "./WebContent.vue";
import Build from "./Build.vue";

export default {
	name: "Footer",

	components: { WebContent, Build  },
	mixins: [webContentMixin ],
	data() {
		return {

		};
	},
	computed: {
		/*loginToken() {

			return this.$store.state.loginToken;

		},*/

		currentYear(){
			return new Date().getFullYear();
		}



	},
	methods: {
		method() {

		},

	}
};
</script>

<style>
div#footer div#footerList div.box p {
	color: var(--grey-5);
}
</style>

<style scoped>

div#footer-block{
	background: black;
	color: white;
	background-color: gray;
		background-image: linear-gradient(rgb(50, 49, 49), black);
		width: 100%;
		color: white;
		/* Text color for visibility */
		padding: 20px;
		box-sizing: border-box;
}


div.box{
	flex: 1 1 0px;
	min-height:100px;
	padding-left:20px;
	padding-right:20px;
	
	
}

div#footerList div.box div.header div.circle{
	margin-right:10px;
}

div#footerList div.box div.header {
	margin-bottom: 10px;
}



div#footerList > div:not(:last-child) {
	border-right: 1px solid var(--grey-dark-3);
}




 h3, p{
	color:white;
}

div#footerList{
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	
	
		grid-gap: 1px;
}

@media (max-width: 1024px) {
	div#footerList {
		grid-template-columns: repeat(2, 1fr);
		row-gap: 20px;
	}

				div#footerList>div:not(:last-child) {
					border-right: 0px solid transparent;
					/* FP: Unset ovan */
				}
		
				div#footerList>div:nth-child(odd) {
					border-right: 1px solid var(--grey-dark-3);
				}
}

@media (max-width: 768px) {
	div#footerList {
		grid-template-columns: repeat(1, 1fr);
		row-gap: 20px;
	}

	div#footerList>div,
	div#footerList>div:nth-child(odd) {
		border-right: none;
	}
}



</style>